var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconbookgroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.75,
    cy: 16,
    r: 16,
    fill: "#E7F1FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.25 12.5H12.25C12.1174 12.5 11.9902 12.4473 11.8964 12.3536C11.8027 12.2598 11.75 12.1326 11.75 12C11.75 11.8674 11.8027 11.7402 11.8964 11.6464C11.9902 11.5527 12.1174 11.5 12.25 11.5H20.75C20.8826 11.5 21.0098 11.4473 21.1036 11.3536C21.1973 11.2598 21.25 11.1326 21.25 11C21.25 10.8674 21.1973 10.7402 21.1036 10.6464C21.0098 10.5527 20.8826 10.5 20.75 10.5H12.25C11.8522 10.5 11.4706 10.658 11.1893 10.9393C10.908 11.2206 10.75 11.6022 10.75 12V20C10.75 20.3978 10.908 20.7794 11.1893 21.0607C11.4706 21.342 11.8522 21.5 12.25 21.5H22.25C22.5152 21.5 22.7696 21.3946 22.9571 21.2071C23.1446 21.0196 23.25 20.7652 23.25 20.5V13.5C23.25 13.2348 23.1446 12.9804 22.9571 12.7929C22.7696 12.6054 22.5152 12.5 22.25 12.5ZM20 17.5C19.8517 17.5 19.7067 17.456 19.5833 17.3736C19.46 17.2912 19.3639 17.1741 19.3071 17.037C19.2503 16.9 19.2355 16.7492 19.2644 16.6037C19.2934 16.4582 19.3648 16.3246 19.4697 16.2197C19.5746 16.1148 19.7082 16.0433 19.8537 16.0144C19.9992 15.9855 20.15 16.0003 20.287 16.0571C20.4241 16.1139 20.5412 16.21 20.6236 16.3333C20.706 16.4567 20.75 16.6017 20.75 16.75C20.75 16.9489 20.671 17.1397 20.5303 17.2803C20.3897 17.421 20.1989 17.5 20 17.5Z",
    fill: "#1271FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconbookgroup);
export default __webpack_public_path__ + "static/media/icon.book.group.bb4562e367118da6b1933e146ad68aa9.svg";
export { ForwardRef as ReactComponent };